import { render } from "./PhotoListItem.vue?vue&type=template&id=48b4c077&ts=true"
import script from "./PhotoListItem.vue?vue&type=script&lang=ts"
export * from "./PhotoListItem.vue?vue&type=script&lang=ts"

import "./PhotoListItem.vue?vue&type=style&index=0&id=48b4c077&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__